/* eslint-disable space-before-function-paren */
import VueScrollTo from 'vue-scrollto';
import Fuse from "fuse.js";

export default {
    SET_APP_LOADED(state, payload) {
        state.appLoaded = payload;
    },
    SET_CPR(state, payload) {
        state.cpr = payload;
    },
    SET_DEV_ENV(state, payload) {
        state.devEnv = payload;
    },
    SET_DM_VALID(state, payload) {
        state.dmValid = payload;
    },
    SET_MA_VALID(state, payload) {
        state.maValid = payload;
    },
    SET_CHILD_URL(state, payload) {
        state.childUrl = payload;
    },
    SET_EDUCATIONS(state, payload) {
        state.educations = payload;
    },
    SET_ERROR(state, payload) {
        state.error = payload;
    },
    SET_IS_TRUSTEE(state, payload) {
        state.isTrustee = (payload === 'true');
    },
    SET_INSTITUTES(state, payload) {
        state.institutes = payload;
    },
    SET_COUNTRIES(state, payload) {
        state.countries = payload;
    },
    SET_MA_COUNTRIES(state, payload) {
        state.maCountries = payload;
    },
    SET_FUNDS(state, payload) {
        state.funds = payload;
    },
    SET_EDUCATIONLEVEL(state, payload) {
        state.member.educationLevel = payload;
    },
    SET_EDUCATION(state, payload) {
        state.member.education = payload;
    },
    SET_MEMBER(state, payload) {
        state.member = payload;

        state.member.educationStartMonth = null;
        state.member.educationStartYear = null;
        state.member.educationMonth = null;
        state.member.educationYear = null;
        state.member.maternityDate = null;
        state.member.pensionDate = null;
        state.member.jobStartFullDate = null;
    },
    SET_MEMBER_CELLULARPHONE(state, payload) {
        state.member.cellularPhone = payload;
    },
    SET_MEMBER_CELL_COUNTRY(state, payload) {
        state.member.phonePrefix = payload;
    },
    SET_MEMBER_CELL_COUNTRY_ISO(state, payload) {
        state.member.phonePrefixIso = payload;
    },
    SET_UMBRACO_ID(state, payload) {
        state.umbracoId = payload;
    },
    SET_TEXT(state, payload) {
        state.text = payload;
    },
    SET_KL_MEMBER(state, payload) {
        state.klMember = payload;
        state.member.isKl = payload;
    },
    SET_GL_MEMBER(state, payload) {
        state.glMember = payload;
        state.member.isGl = payload;
    },
    SET_STEPS(state) {
        state.member.formType = state.formType;
        state.member.subType = state.subType;

        if (state.subType == "ordinary" || state.subType == "freelancer") {
            state.steps = state.components.default.concat(state.components.ordinary);
        } else {
            state.steps = state.components.default;
        }

        if (state.akasse == true) {
            state.steps = state.steps.concat(state.components.akasse);
        }


        // ma = MA-AKASSE ONLY - dmma = BOTH - dm = MAGISTER ONLY
        // if (state.formType === "ma") {
        //     state.steps = state.components.akasse;
        // } else if (state.formType === "dmma") {
        //     state.steps = state.components.both;
        // } else if (state.formType === "dm") {
        //     state.steps = state.components.magister;
        // }

        state.steps.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
        });

        const firstComponent = state.steps[0];

        firstComponent.isActive = true;
        state.currentComponent = firstComponent;
    },
    SET_CURRENT_COMPONENT(state, payload) {
        state.currentComponent = payload;
        const component = state.steps.find(comp => {
            return comp.name === payload.name;
        });
        component.isActive = true;

        VueScrollTo.scrollTo('.member-form-top', 1, state.scrollOptions);
    },
    SET_FORM_TYPE(state, payload) {
        state.formType = payload;
    },
    SET_CONSENT_TEXT_OBJECT(state, payload) {
        state.consentTextObject = payload;
    },
    SET_NEWS_LETTER_TEXT(state) {
        if (state.formType === "dmma") {
            state.newsLetterText = state.english ? state.consentTextObject.consentDmMaTextEnglish : state.consentTextObject.consentDmMaText;
            state.newsLetterTextExtra = state.english ? state.consentTextObject.consentExtraDmMaTextEnglish : state.consentTextObject.consentExtraDmMaText;
        } else if (state.formType === "dm") {
            state.newsLetterText = state.english ? state.consentTextObject.consentDmTextEnglish : state.consentTextObject.consentDmText;
            state.newsLetterTextExtra = state.english ? state.consentTextObject.consentExtraDmTextEnglish : state.consentTextObject.consentExtraDmText;
        }
    },
    VALIDATE_CURRENT_COMPONENT(state, payload) {
        state.currentComponent.isValid = payload;
    },
    VALIDATE_COMPONENT(state, payload) {
        var component = state.steps.find(x => x.name == payload.name);
        component.isValid = payload.value;
    },
    NEXT_COMPONENT(state) {
        var currentIndex = state.steps.indexOf(state.currentComponent);
        state.currentComponent = state.steps[currentIndex + 1];
    },
    PREV_COMPONENT(state) {
        var currentIndex = state.steps.indexOf(state.currentComponent);
        state.currentComponent = state.steps[currentIndex - 1];
    },
    SET_SERVER_RESPONSE(state, payload) {
        state.serverResponse = payload;
    },
    SET_ENGLISH(state, payload) {
        state.english = payload;

        if (state.formType != null) {
            this.commit("SET_NEWS_LETTER_TEXT");
        }
    },
    SET_CAMPAIGN_CODE(state, payload) {
        state.campaignCode = payload;
    },
    SET_CAMPAIGN_CODE_LIST(state, payload) {
        console.log(payload);
        if (payload) {
            var codes = payload.split(',');
            state.campaignCodeList = codes;
        } else {
            state.campaignCodeList = [];
        }

    },
    SET_AKASSE(state, payload) {
        state.akasse = payload;
    },
    SET_IS_CALLCENTER(state, payload) {
        state.isCallCenter = (payload === 'true');
    },
    SET_FULL_FORM_FORMAT(state, payload) {
        state.fullFormFormat = payload;
    },
    SET_SUB_TYPE(state, payload) {
        var selectedGroup = state.selectChoices.find(x => x.value == payload);
        state.subType = selectedGroup.value;
        state.member.contactGroupId = selectedGroup.subGroupId;
    },
    SET_SUBSCRIPTIONS(state, payload) {
        state.subscriptions = payload;
    },
    SET_SUBSCRIPTION_GROUP(state, payload) {
        state.member.subscriptionGroup = payload;
    },
    SET_MEMBER_SUBSCRIPTION(state, payload) {
        var subscription = state.subscriptions.subscriptions.find(x => x.id === payload);
        state.member.subscriptionText = subscription.description;
        state.member.subscription = payload;
    },
    SET_EMPLOYER_LOADING(state, payload) {
        state.employerLoading = payload;
    },
    SET_EMPLOYERS(state, payload) {
        state.employers = payload;
        state.fuseSearch = new Fuse(payload, {
            keys: ["name", "tokens"],
            threshold: 0.2,
            ignoreDiacritics: true,
            distance: 200,
            shouldSort: true,
            findAllMatches: true,
            ignoreFieldNorm: true,
            ignoreLocation: true,
            includeScore: true,
            useExtendedSearch: true,
        });
    },
    SET_HELPBENEFITS(state, payload) {
        state.member.helpBenefits = payload;
    },
    SET_HALF_MEMBER(state, payload) {
        state.halfMember = payload;
    },
    SET_MATERNITY(state, payload) {
        state.maternity = payload;
    },
    SET_JOBS(state, payload) {
        state.jobs = payload;
    },
    SET_DM_JOB_POSITIONS(state, payload) {
        state.jobPositions = payload;
    },
    SET_JOB_TYPES(state, payload) {
        state.jobTypes = payload;
    },
    SET_BANKACCOUNT(state, payload = null) {
        state.member.bankAccount = payload;
    },
    SET_BANKREGNUM(state, payload = null) {
        state.member.bankRegNum = payload;
    },
    SET_PENSION_TYPE(state, payload) {
        state.pensionType = payload;

        state.member.isPension = payload === 1;
        state.member.isPensionCivil = payload === 2;
    },
    SET_MA_NOT_ALLOWED_WARNING(state, payload) {
        state.maNotAllowedWarning = payload;
    },
    SET_STUDENTS_URL(state, payload) {
        state.studentsUrl = payload;
    },
    SET_TITLE(state, payload) {
        state.title = payload;
    },
    SET_SUBTITLE(state, payload) {
        state.subTitle = payload;
    },
    SET_GTM_SHOWN(state, payload) {
        var component = state.steps.find(x => x.name == payload.name);
        component.isGtmShown = true;
    },
    SET_EDUCATION_LOADED(state, payload) {
        state.educationLoaded = payload;
    },
    SET_EDUCATION_ERROR(state, payload) {
        state.educationError = payload;
    },
    SET_WORK_LOADED(state, payload) {
        state.workLoaded = payload;
    },
    SET_WORK_ERROR(state, payload) {
        state.workError = payload;
    },
    SET_MA_LOADED(state, payload) {
        state.maLoaded = payload;
    },
    SET_MA_ERROR(state, payload) {
        state.maError = payload;
    },
    SET_PRESENTS(state, payload) {
        state.presents = payload;
    },
    SET_CAMPAIGN_CONDITIONS(state, payload) {
        state.campaignConditions = payload;
    },
    SET_SELECTED_GIFT(state, payload) {
        state.selectedGift = payload;
    },
    SET_ANTIFORGERY_TOKEN(state, payload) {
        state.antiforgeryToken = payload;
    },
    SET_ADVERSUSWEBHOOK_ENABLED(state, payload) {
        state.adversusWebhookEnabled = payload === 'true';
    },
    SET_ENROLLMENT_GUID(state, payload) {
        state.enrollmentGuid = payload;
        state.clientDiagnostics.startedAt = Date.now();
    },
    TRACK_STEP(state, stepName) {
        const history = state.clientDiagnostics.stepHistory;
        history.push(stepName);
        if (history.length > 30) {
            history.shift();
        }
    },
    INCREMENT_SUBMIT_ATTEMPTS(state) {
        state.clientDiagnostics.submitAttempts++;
    },
    SET_WORKING_AREAS(state, payload) {
        state.workingAreas = payload;
    },
    SET_WORK_FORM_STATE(state, {property, value}) {
        if (state.workFormState.hasOwnProperty(property)) {
            state.workFormState[property] = value;
        }
    },
    SET_PAGE_VIEW_ID(state, payload) {
        state.pageViewId = payload;
    },
};